// patterns.js

// Each pattern:
//   priority: processing order (lower = first)
//   example: what the user might say (for reference only)
//   match: regex with named capture groups for numbers
//   replace: function that takes the captured groups and returns LaTeX

const patterns = [
  {
    priority: 1,
    example: "integration of 3 x square dx",
    match: /integration\s+of\s+(?<a>\d+)\s*x\s+square\s+dx/gi,
    replace: (g) => `\\int ${g.a}x^{2}\\,dx`,
  },
  {
    priority: 2,
    example: "5 divided by 3",
    match: /(?<a>\d+)\s+divided\s+by\s+(?<b>\d+)/gi,
    replace: (g) => `\\frac{${g.a}}{${g.b}}`,
  },
  {
    priority: 3,
    example: "2 by 3",
    match: /(?<a>\d+)\s+by\s+(?<b>\d+)/gi,
    replace: (g) => `\\frac{${g.a}}{${g.b}}`,
  },
  {
    priority: 4,
    example: "square root of 9",
    match: /square\s+root\s+of\s+(?<a>\d+)/gi,
    replace: (g) => `\\sqrt{${g.a}}`,
  },
  {
    priority: 5,
    example: "4 to the power 5",
    match: /(?<a>\d+)\s+to\s+the\s+power\s+(?<b>\d+)/gi,
    replace: (g) => `${g.a}^{${g.b}}`,
  },
  {
    priority: 6,
    example: "4 power 5",
    match: /(?<a>\d+)\s+power\s+(?<b>\d+)/gi,
    replace: (g) => `${g.a}^{${g.b}}`,
  },
  {
    priority: 7,
    example: "9 square",
    match: /(?<a>\d+)\s+squared/gi,
    replace: (g) => `${g.a}^{2}`,
  },
  {
    priority: 8,
    example: "9 cube",
    match: /(?<a>\d+)\s+cubed/gi,
    replace: (g) => `${g.a}^{3}`,
  },
  {
    priority: 9,
    example: "44 times 36",
    match: /(?<a>\d+)\s+times\s+(?<b>\d+)/gi,
    replace: (g) => `${g.a}\\times ${g.b}`,
  },
  {
    priority: 10,
    example: "x subscript 2",
    match: /(?<a>\w+)\s+subscript\s+(?<b>\w+)/gi,
    replace: (g) => `${g.a}_{${g.b}}`,
  },
  {
    priority: 11,
    example: "limit of x approaches 0",
    match: /limit\s+of\s+(?<a>\w+)\s+approaches\s+(?<b>\w+)/gi,
    replace: (g) => `\\lim_{${g.a}\\to ${g.b}}`,
  },
  {
    priority: 12,
    example: "sum of i from 1 to 10",
    match: /sum\s+of\s+(?<a>\w+)\s+from\s+(?<b>\w+)\s+to\s+(?<c>\w+)/gi,
    replace: (g) => `\\sum_{${g.a}=${g.b}}^{${g.c}}`,
  },
  {
    priority: 13,
    example: "integration from 0 to 5",
    match: /integration\s+from\s+(?<a>\w+)\s+to\s+(?<b>\w+)/gi,
    replace: (g) => `\\int_{${g.a}}^{${g.b}}`,
  },
];

export default patterns;